// AI Generated Test
import { Component, forwardRef, Input, OnInit, ElementRef, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { safeClone } from '@client/app/shared/utils/object-utils';

@Component({
    selector: 'form-field-checkbox-in-line',
    templateUrl: './form-field-checkbox-in-line.component.html',
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormFieldCheckboxInLineComponent),
            multi: true,
        },
    ],
})
export class FormFieldCheckboxInLineComponent implements OnInit, ControlValueAccessor, AfterViewInit {
    @Input() label: string = '';
    @Input() helpTxt: string = '';
    @Input() options: any[] = [];
    @Input() returnValue: string = 'name';
    @Input() ngRequired: boolean = false;

    @Output() ngChange = new EventEmitter<any[]>();

    @ViewChild('formGroupRef', { static: true }) formGroupRef!: ElementRef;

    private _value: any[] = [];
    private _onChange = (value: any) => {};
    private _onTouched = () => {};
    public _isTouched = false;

    constructor (private elementRef: ElementRef) {}

    ngOnInit (): void {
        this.returnValue = this.returnValue || 'name';
        this.ngRequired = this.ngRequired || false;
        this._value = this._value || [];
    }

    ngAfterViewInit (): void {
        this.updateValidationClasses();
    }

    get value (): any[] {
        return this._value;
    }

    set value (val: any[]) {
        if (val !== this._value) {
            this._value = val || [];
            this._onChange(this._value);
            this._onTouched();
        }
    }

    writeValue (value: any[]): void {
        if (value !== undefined && value !== null) {
            this._value = Array.isArray(value) ? safeClone(value) : [];
        } else {
            this._value = [];
        }
    }

    registerOnChange (fn: any): void {
        this._onChange = fn;
    }

    registerOnTouched (fn: any): void {
        this._onTouched = fn;
    }

    setDisabledState (isDisabled: boolean): void {
        // Handle disabled state if needed
    }

    toggleSelection (option: any): void {
        const value = option[this.returnValue];
        const index = this.getIndex(value);

        if (index > -1) {
            this._value.splice(index, 1);
        } else {
            this._value.push(value);
        }

        this._onChange(this._value);
        this.ngChange.emit(this._value);
        this.updateValidationClasses();
    }

    getIndex (value: any): number {
        let index = -1;
        for (let i = 0; i < this._value.length; i++) {
            if (this._value[i] === value) {
                index = i;
                break;
            }
        }
        return index;
    }

    isChecked (option: any): boolean {
        return this.getIndex(option[this.returnValue]) > -1;
    }

    onInputBlur (): void {
        this._isTouched = true;
        this._onTouched();
        this.updateValidationClasses();
    }

    isFieldValid (): boolean {
        if (this.ngRequired && (!this._value || this._value.length === 0)) {
            return false;
        }
        return true;
    }

    public updateValidationClasses (): void {
        if (!this.formGroupRef) {
            return;
        }

        const formGroupElement = this.formGroupRef.nativeElement;
        const isValid = this.isFieldValid();

        if (!isValid && this._isTouched) {
            this.setHasError(formGroupElement);
        } else {
            this.removeHasError(formGroupElement);
        }
    }

    private setHasError (formGroupElement: HTMLElement): void {
        if (!formGroupElement.classList.contains('has-error')) {
            formGroupElement.classList.add('has-error');
        }
    }

    private removeHasError (formGroupElement: HTMLElement): void {
        if (formGroupElement.classList.contains('has-error')) {
            formGroupElement.classList.remove('has-error');
        }
    }
}
